var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-content',{attrs:{"code":"404","desc":"您浏览的页面不存在","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }